import { editOldQuotes } from "../../../helpers/quote_order/quote.helper";
import { kLinkService } from "../../../services/quote-order.service";

export const createGeDefaultBuildingData = (deps) => {
	const { params, const_var, calcOverhangSize, utils, editInventoryService, editOrderService, editQuoteService, getDealerStateList, setQuoteStateCountForNonLoggedIn, setPricingData, setPdfFile } = deps;
	function geDefaultBuildingData(selectedBuilding = null) {
		params.apiCallAfterEdit = true;
		const_var.showProcessLoaderchkEdit = true;
		let settingData = const_var.crmSetting;
		let apiData = "";
		if (const_var.crmSetting.is_module_name == "inventory" && const_var.crmSetting.form_action == "duplicate" && const_var.crmSetting.sub_module == "") {
			const_var.crmSetting.sub_module = "lead"; //Add the condition beacuse when user create a quote from inventory in that that case sub_module is going blank
		}
		const_var["prevModuleType"] = settingData.is_module_name;
		if (const_var.crmSetting.duplicate_module != "" && settingData.is_module_name == "inventory" && settingData.sub_module_id != "" && settingData.sub_module != "") {
			apiData = { api_token: settingData.api_token, module: settingData.is_module_name, module_id: settingData.is_module_id, sub_module_name: settingData.sub_module, sub_module_id: settingData.sub_module_id };
		} else {
			apiData = { api_token: settingData.api_token, module: settingData.is_module_name, module_id: settingData.is_module_id };
		}
		if (const_var.crmSetting.is_quote_Edit) {
			apiData.is_all_manufacturers = true;
		}
		let apiUrl = settingData.api_post_url + "/api/v1/order/edit";
		if (selectedBuilding?.id) {
			apiData.module_id = selectedBuilding?.id;
		}
		let NewBuildingresponse = [];
		const_var.noCursorClass = false;
		let editService = null;
		switch (const_var.crmSetting.is_module_name) {
			case "inventory":
				editService = editInventoryService;
				break;
			case "quote":
				editService = editQuoteService;
				break;
			case "order":
				editService = editOrderService;
				break;
		}
		return (dispatch) => {
			return editService(const_var.crmSetting.is_module_id)
				.then(async (res) => {
					const response = { data: res };
					if (response.data.data != undefined && (response.data.data?.company_id != undefined || response.data.data?.request_data?.company_id != undefined)) {
						params.company_id = response.data.data?.company_id || response.data.data?.request_data?.company_id;
					}
					if (response?.data?.data?.request_data?.building?.additionalFeaturesArray && const_var.crmSetting.is_Edit) {
						response.data.data.request_data.building.additionalFeaturesArray = response.data.data.request_data.building.additionalFeaturesArray?.filter((item) => {
							if (item?.is_checked) return item;
						});
					}

					if (response.data?.data?.request_data?.building) {
						const_var.is_edit_extra_labour = response.data.data.request_data.building.is_edit_extra_labour || false;
						const_var.edit_utility = true;
					}
					if (response.data?.data?.request_data?.building?.leanto.length > 0) {
						response.data.data.request_data.building.leanto.forEach((leanData) => {
							if (leanData.leanto_style == "gable") {
							}
						});
					}
					response?.data?.data?.request_data?.building?.entry_points?.map((e) => {
						if (e.nested_array_key === "Garage Door") {
							e.nested_array_key = "Roll-Up";
						}
					});

					response?.data?.data?.pricing_data?.garage_door_v3?.standard_door?.map((e) => {
						if (e.name === "Garage Door") {
							e.name = "Roll-Up";
						}
					});

					response?.data?.data?.building_data?.default_building?.map((e) =>
						e.default_doors?.map((d) => {
							if (d.category === "Garage Door") {
								d.category = "Roll-Up";
							}
						})
					);
					let DomainURI = window.location.href;
					if (
						DomainURI?.includes("3d-public") &&
						(response.data?.data?.request_data?.sensei_sales_id || response.data?.data?.request_data?.sensei_sales_id == "" || response.data?.data?.request_data?.company_id)
					) {
						const_var.requestApiToken = response.data?.data?.request_data?.api_token;
					}
					if (response?.data?.data?.request_data?.building?.insulation_type?.insulation_wall != undefined && response?.data?.data?.request_data?.building?.insulation_type?.insulation_wall == 0) {
						response.data.data.request_data.building.insulation_type.insulation_wall = {};
					}
					const_var.isUpdate4ftLegLogic = /* false */ params.m_s_n == 3 ? true : false;
					if (response.data.data.request_data != undefined && const_var.crmSetting.duplicate_module == "inventory") {
						response.data.data.request_data.building.lifttype_price = 0;
					}
					if (response.data.data.request_data != undefined && response.data.data.request_data.building?.installationsurfaceChange == undefined) {
						const_var.installationsurfaceChange = false;
					}
					if (response.data.data?.request_data?.building?.discount_info) {
						const_var.discount_info = response.data.data.request_data.building.discount_info;
					}
					// const_var.isCheckColoredScrews = false;
					if (response.data.data.request_data == undefined) {
						response.data.data.request_data = [];
						response.data.data.request_data["building"] = response.data.data.form_data;
					}
					if (response.data.data.request_data && const_var.crmSetting.is_zipcode_screen != true) {
						dispatch(setQuoteStateCountForNonLoggedIn(response.data.data, response.data.data.states));
					}

					/*For old quotes*/
					if (
						response.data.data.request_data != undefined &&
						response.data.data.request_data.building.manufacturer !== 2 &&
						response.data.data.request_data.building.manufacturer !== 17 &&
						(response.data.data.request_data.building.display_building_type_name.includes("Free Standing Buildings") ||
							response.data.data.request_data.building.display_building_type_name.includes("Free Standing Lean-to"))
					) {
						editOldQuotes(response);
					}
					if (response.data.data.pricing_data != undefined) {
						if (response.data.data.pricing_data.window_frameout_v3 != undefined) {
							Object.entries(response.data.data.pricing_data.window_frameout_v3).map(([key, value], index) => {
								for (var i = 0; i < response.data.data.pricing_data.window_frameout_v3[key].length; i++) {
									if (response.data.data.pricing_data.window_frameout_v3[key][i].name == "Man Door") {
										response.data.data.pricing_data.window_frameout_v3[key][i].name = "Standard";
									}
								}
							});
						}
					}

					if (response.data.data.pricing_data.garage_door_v3 != undefined && response.data.data.pricing_data.garage_door_v3.overhead_door_door != undefined) {
						utils.manageOverheadDoorObject(response);
					}

					if (const_var.crmSetting.duplicate_module != "" && settingData.is_module_name == "inventory") {
						const_var.crmSetting.is_module_name = const_var.crmSetting.duplicate_module;
					}
					if (const_var.crmSetting.duplicate_module == "inventory" && settingData.is_module_name == "order") {
						const_var.crmSetting.is_module_name = const_var.crmSetting.duplicate_module;
						params.display_product_status = "in_stock";
						response.data.data.request_data.status = params.display_product_status;
					}
					let checkImages = response.data.data.building_images.filter((data) => data.is_checked != undefined && data.is_checked == true);
					if (checkImages.length > 0) {
						const_var.checkIsEditData = true;
					} else {
						const_var.checkIsEditData = false;
					}
					const_var.UpdatedPriceData.surcharge_amount = undefined;
					if (
						response.data.data != undefined &&
						response.data.data.request_data != undefined &&
						response.data.data.request_data.building != undefined &&
						response.data.data.request_data.building.order_extra_items != undefined &&
						(response.data.data.request_data.building.order_extra_items.engineer_drawings_name != undefined || response.data.data.request_data.building.order_extra_items.engineer_drawings_name != "None")
					) {
						const_var.engineer_drawings_price_changed = false;
						const_var.updated_engineer_drawings_price = response.data.data.request_data.building.order_extra_items.engineer_drawings;
					}
					if (
						const_var.crmSetting.is_zipcode_screen != undefined &&
						const_var.crmSetting.is_zipcode_screen == true &&
						response.data.data.request_data != undefined &&
						response.data.data.request_data.building != undefined &&
						response.data.data.request_data.building.state_mfg_zipcode != undefined &&
						response.data.data.request_data.building.state_mfg_zipcode != null &&
						response.data.data.request_data.building.state_mfg_zipcode != ""
					) {
						const_var.state_mfg_zipcode = response.data.data.request_data.building.state_mfg_zipcode;
					}
					if (
						response.data.data != undefined &&
						response.data.data.request_data != undefined &&
						response.data.data.request_data.building != undefined &&
						response.data.data.request_data.building.old_permit_Fee != undefined
					) {
						const_var.exact_order_permit_fee = response.data.data.request_data.building.old_permit_Fee;
						const_var.old_permit_Fee = response.data.data.request_data.building.old_permit_Fee;
					}
					{
						if (response?.data?.data?.building_data?.color_data) {
							let newColorObject = response.data.data.building_data.color_data.reduce((acc, item) => {
								acc[item.id] = item;
								return acc;
							}, {});
							response.data.data.building_data.color_object = newColorObject;
						}
						response.data?.data?.request_data?.building?.additionalFeaturesArray?.map((value, key) => {
							if (value != null) {
								const_var.isCheckColoredScrews = false;
								if (value.cost_type != undefined) {
									if (value.cost_type == "%" && (value.percentage_of == null || value.percentage_of == "")) value.cost_type = "$";
								}
								if (value.additional_feature.toLowerCase().includes("colored screws")) {
									const_var.isCheckColoredScrews = true;
								}
							}
						});

						if (response.data?.data?.building_data?.default_building.filter((data) => data.heavy_snow == 0).length == 0) {
							const_var.CheckSnowLoadValue = 65;
							const_var.noCursorClass = true;
						}

						if (response.data.data.pricing_data.cupola && Object.keys(response.data.data.pricing_data.cupola).length > 0) {
							if (Array.isArray(response.data.data.pricing_data.cupola)) {
								response.data.data.pricing_data.cupola = {
									without_windows: response.data.data.pricing_data.cupola.map((cupola) => {
										return {
											id: cupola.id,
											map_id: cupola["`map_id`"],
											structure: cupola.structure,
											cost: cupola.cost,
											name: "Without Windows",
											slug: "without_windows"
										};
									})
								};
							}
						}

						const_var.editAPIDataByResponse = response.data;
						const_var.selectedBuildingUniqId = const_var.editAPIDataByResponse?.data?.request_data?.building?.selectedBuildingUniqueId;
						if (const_var.editAPIDataByResponse.data.building_data != undefined && Object.keys(const_var.editAPIDataByResponse.data.building_data).length > 0) {
							let checkLNT = [];
							const_var.editAPIDataByResponse.data.building_data.default_building.forEach((item, index) => {
								if (item.name.includes("Shape") || item.name.includes("Front to Back")) {
									checkLNT = [...checkLNT, item];
								}
								const BuildingMainData = const_var.editAPIDataByResponse.data.building_data.building.filter((building) => Number(building.building_type?.default_building) == item.building_id);
								if (BuildingMainData.length == 0) {
									const_var.editAPIDataByResponse.data.building_data.default_building.splice(index, 1);
								}
							});
							if (checkLNT.length > 0 && const_var.editAPIDataByResponse.data?.request_data?.custom_building == 1) {
								let checkGableMapping = const_var.editAPIDataByResponse.data.building_data.building.find(
									(building) => building.building_type.building_id == const_var.editAPIDataByResponse.data?.request_data.building.building_type
								);

								if (checkGableMapping?.gable_mapping === undefined || checkGableMapping?.gable_mapping?.length === 0) {
									let newData = checkGableMapping.roof_style.find((s) => s.roof_id == const_var.editAPIDataByResponse.data?.request_data.building.roof_style);

									if (newData) {
										checkGableMapping.gable_mapping = [
											{
												map_id: newData.map_id,
												min_width: newData.min_width,
												max_width: newData.max_width,
												distance_on_width: newData.distance_on_width,
												min_height: newData.min_height,
												max_height: newData.max_height,
												min_length: newData.start_length,
												max_length: newData.end_length,
												distance_on_length: newData.distance_on_length
											}
										];
									}
								}
							}
						}
						if (response?.data?.data?.pricing_data?.jtrim?.length == 1) {
							if (response.data.data.pricing_data.jtrim[0].type == undefined) {
								response.data.data.pricing_data.jtrim[0].type = "side";
							}
						}
						if (response.data?.data?.request_data?.building?.has_utility == true) {
							response.data.data.request_data.building.utility_name = response.data.data.request_data.building.utility_name == undefined ? "back" : response.data.data.request_data.building.utility_name;
						}
						if (response?.data?.data?.request_data?.building?.order_extra_items?.freight_fee != undefined) {
							response.data.data.request_data.building.order_extra_items.freight = response.data.data.request_data.building.order_extra_items.freight_fee;
						}
						const_var.AllBuildingData = { data: response.data.data.building_data };
						const_var.AllBuildingData.success = true;
						const_var.AllBuildingData.message = "success";
						const_var.duplicateTaxZipCode = response.data.data.request_data.building.tax_zipcode;

						if (response?.data?.data?.request_data?.building?.ExtraItemsFeaturesArray?.length > 0) {
							let overhangOpt = response.data.data.request_data.building.ExtraItemsFeaturesArray.filter((obj) => obj != null && obj.name && obj.name == "overhang");
							let endOverhang = [];
							let sideOverhang = "";
							let bothOverhang = "";
							let EndSize = 0.5;
							let SideSize = 0.5;
							let BothSize = 0.5;

							endOverhang = overhangOpt.filter((obj) => obj.label.toLowerCase().includes("end"));
							sideOverhang = overhangOpt.filter((obj) => obj.label.toLowerCase().includes("side"));
							bothOverhang = overhangOpt.filter((obj) => obj.label.toLowerCase().includes("both") && obj.sheet_type != undefined && obj.sheet_type == "both");

							if (
								response.data.data.pricing_data.overhang != undefined &&
								((response.data.data.pricing_data.overhang.end != undefined && response.data.data.pricing_data.overhang.end.length > 0) ||
									(response.data.data.pricing_data.overhang.side != undefined && response.data.data.pricing_data.overhang.side.length > 0) ||
									(response.data.data.pricing_data.overhang.both != undefined && response.data.data.pricing_data.overhang.both != "" && response.data.data.pricing_data.overhang.both != null))
							) {
								EndSize = endOverhang.length > 0 ? calcOverhangSize(endOverhang != undefined && endOverhang[0].sheet_name ? endOverhang[0].sheet_name : endOverhang[0].name) : 0.5;
								SideSize = sideOverhang.length > 0 ? calcOverhangSize(sideOverhang != undefined && sideOverhang[0].sheet_name ? sideOverhang[0].sheet_name : sideOverhang[0].name) : 0.5;
								BothSize = bothOverhang.length > 0 ? calcOverhangSize(bothOverhang != undefined && bothOverhang[0].sheet_name ? bothOverhang[0].sheet_name : bothOverhang[0].name) : 0.5;
								params.o_v_h_n_g = SideSize != 0.5 || BothSize != 0.5 ? true : false;
								params.o_v_h_n_g_e = EndSize != 0.5 || BothSize != 0.5 ? true : false;
							} else {
								EndSize = endOverhang.length > 0 ? 1 : 0.5;
								SideSize = sideOverhang.length > 0 ? 1 : 0.5;
								BothSize = bothOverhang.length > 0 ? 1 : 0.5;
							}
							const_var.isOverhang = {
								end: {
									isChecked: endOverhang.length > 0 ? true : false,
									selected: endOverhang.length > 0 ? (endOverhang[0].sheet_name ? endOverhang[0].sheet_name : endOverhang[0].label) : "",
									size: bothOverhang.length > 0 ? 1 : EndSize
								},
								side: {
									isChecked: sideOverhang.length > 0 ? true : false,
									selected: sideOverhang.length > 0 ? (sideOverhang[0].sheet_name ? sideOverhang[0].sheet_name : sideOverhang[0].label) : "",
									size: bothOverhang.length > 0 ? 1 : SideSize
								},
								both: {
									isChecked: bothOverhang.length > 0 ? true : false,
									selected: bothOverhang.length > 0 ? (bothOverhang[0].sheet_name ? bothOverhang[0].sheet_name : bothOverhang[0].label) : "",
									size: BothSize
								}
							};
						}

						const_var.ConditionArrForLean = [];
						dispatch({
							type: "SETDEFAULTCONFIGURATION",
							value: response.data.data
						});

						await dispatch(getDealerStateList());

						dispatch(setPricingData(response));
						if (const_var.loginSession) {
							setPdfFile(dispatch);
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		};
	}

	return geDefaultBuildingData;
};

export const createGeDefaultBuildingDataForKlink = (deps) => {
	const { params, const_var, utils, getDealerStateList, setQuoteStateCountForNonLoggedIn, savePriceComparisionDataForNotLoggedIn } = deps;
	function geDefaultBuildingDataForKlink(DomainURI) {
		params.apiCallAfterEdit = true;
		const_var.showProcessLoaderchkEdit = true;
		return async (dispatch) => {
			return kLinkService(DomainURI[1])
				.then(async function (response) {
					response = {
						data: response
					};
					if (response.data?.data?.request_data?.building) {
						const_var.edit_utility = true;
					}
					/*---------------- Extra add on feature ----------------------*/
					if (response.data?.data?.request_data?.building && response.data?.data?.request_data?.building?.custom_labor) {
						utils.extraAddOnRoofPitchEditData(response);
					}
					/*---------------- End of Extra add on feature ----------------------*/

					/*------------Add this condition to blank additional notes in case on klink-----------*/
					if (response.data?.data?.request_data?.building) {
						response.data.data.request_data.building["additional_note"] = "";
						response.data.data.request_data.building.order_extra_items["additional_note"] = "";
					}
					/*------------Add this condition to blank additional notes in case on klink-----------*/

					//------------ Garage Door name change to Roll-Up door handle
					response?.data?.data?.request_data?.building?.entry_points?.map((e) => {
						if (e.nested_array_key === "Garage Door") {
							e.nested_array_key = "Roll-Up";
						}
					});

					response?.data?.data?.pricing_data?.garage_door_v3?.standard_door?.map((e) => {
						if (e.name === "Garage Door") {
							e.name = "Roll-Up";
						}
					});

					response?.data?.data?.building_data?.default_building?.map((e) =>
						e.default_doors?.map((d) => {
							if (d.category === "Garage Door") {
								d.category = "Roll-Up";
							}
						})
					);
					//----------- End: Garage Door name change to Roll-Up door handle

					if (response.data?.data?.request_data?.building?.is_edit_extra_labour) {
						const_var.is_edit_extra_labour = response.data.data.request_data.building.is_edit_extra_labour || false;
					}
					if (response.data.status == false) {
						dispatch({
							type: "ManageKlinkExpire",
							value: response.data.message
						});
					} else {
						if (response.data.data != undefined && (response.data.data.company_id != undefined || (response.data.data.request_data != undefined && response.data.data.request_data.company_id != undefined))) {
							params.company_id = response.data.data?.company_id || response.data.data.request_data.company_id;
						}

						if (response.data.data.request_data == undefined) {
							response.data.data.request_data = [];
							response.data.data.request_data["building"] = response.data.data.form_data;
						}
						response.data.data.tax = {};
						response.data.data.building_images = [];
						response.data.data.personal_info = {
							id: "",
							first_name: "",
							last_name: "",
							email: "",
							email_2: "",
							phone_no: "",
							phone_no_2: "",
							mobile_no: "",
							source: "",
							sensei_sales_id: "",
							u_id: "",
							address: []
						};
						if (response.data.data.request_data) {
							if (response.data.data?.request_data?.building?.discount_rate_updated) {
								response.data.data.request_data.building.manufacturer_discount_label = "";
								response.data.data.request_data.building.manufacturer_discount_changed = false;
								response.data.data.request_data.building.discount_rate = 0;
								response.data.data.request_data.building.discount_type = "per";
								response.data.data.request_data.building.discount_amount = 0;
								response.data.data.request_data.building.discount_rate_updated = undefined;
							}
							dispatch(setQuoteStateCountForNonLoggedIn(response.data.data, response.data.data.state));
						}
						if (
							response.data.data.request_data != undefined &&
							response.data.data.request_data.building.manufacturer !== 2 &&
							response.data.data.request_data.building.manufacturer !== 17 &&
							(response.data.data.request_data.building.display_building_type_name.includes("Free Standing Buildings") ||
								response.data.data.request_data.building.display_building_type_name.includes("Free Standing Lean-to"))
						) {
							editOldQuotes(response);
						}
						if (response.data.data.pricing_data.cupola && Object.keys(response.data.data.pricing_data.cupola).length > 0) {
							if (Array.isArray(response.data.data.pricing_data.cupola)) {
								response.data.data.pricing_data.cupola = {
									without_windows: response.data.data.pricing_data.cupola.map((cupola) => {
										return {
											id: cupola.id,
											map_id: cupola["`map_id`"],
											structure: cupola.structure,
											cost: cupola.cost,
											name: "Without Windows",
											slug: "without_windows"
										};
									})
								};
							}
						}
						if (response?.data?.data?.pricing_data?.garage_door_v3?.overhead_door_door) {
							utils.manageOverheadDoorObject(response);
						}
						const name = response?.data?.data?.request_data?.building?.order_extra_items?.engineer_drawings_name;
						if (name && name !== "None") {
							const_var.engineer_drawings_price_changed = false;
							const_var.updated_engineer_drawings_price = response.data.data.request_data.building.order_extra_items.engineer_drawings;
						}

						const_var.editAPIDataByResponse = response.data;
						const_var.showFullPageLoader = false;
						const_var.AllBuildingData.data = response.data.data.building_data;
						const_var.AllBuildingData.success = true;
						const_var.AllBuildingData.message = "success";
						dispatch({
							type: "SETDEFAULTCONFIGURATION",
							value: response.data.data
						});
						await dispatch(getDealerStateList());

						let stateId = params.p_s_n;
						let abc = response.data.data.state ? response.data.data.state : response.data.data.states;

						let selectedState = abc.find((state) => state.id == stateId);
						if (selectedState && selectedState?.manufacturer_list?.price_comparision?.length > 0) {
							const key = `selectedState_${stateId}`;
							let mfgList = [selectedState?.manufacturer_list, ...selectedState?.manufacturer_list?.price_comparision];
							const_var.hideCompareOption = false;
							dispatch(savePriceComparisionDataForNotLoggedIn(key, mfgList));
						} else {
							const_var.hideCompareOption = true;
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		};
	}

	return geDefaultBuildingDataForKlink;
};
